import consoleConnectLogo from "@assets/Logos/ConsoleConnect.svg";
import equinixLogo from "@assets/Logos/Equinix.svg";
import megaportLogo from "@assets/Logos/Megaport.svg";

/**
 * The logo of the fabric provider a name refers to — the counterpart of
 * `resolveCloudProviderLogo` for the companies that carry a cloud connection
 * (and, for Equinix, also run the data center). Matches the name as people
 * write it: "Megaport", "Equinix Fabric", "Console Connect", "EQUINIX MX2".
 * `null` when we hold no logo, so the caller keeps its own icon instead of a
 * guess.
 */
const LOGO_BY_PATTERN: ReadonlyArray<[RegExp, string]> = [
  [/\bmegaport\b/i, megaportLogo],
  [/\bconsole\s*connect\b/i, consoleConnectLogo],
  [/\bequinix\b/i, equinixLogo],
];

export function resolveFabricProviderLogo(name: string | null | undefined): string | null {
  if (!name) return null;
  return LOGO_BY_PATTERN.find(([pattern]) => pattern.test(name))?.[1] ?? null;
}
